// extracted by mini-css-extract-plugin
export var dropdownButton = "_3q-0";
export var fullWidthDropdownButton = "_3q-1";
export var icon = "_3q-3";
export var iconPlaceholder = "_3q-2";
export var menuItemRow = "_3q-5";
export var shortcutContainer = "_3q-4";